
export const isCollapsed = (isCollapsed) => ({
  type: "COLLAPSED",
  isCollapsed
});

